<div>
  <app-lista-dados
    [upTitulo]="'Lista de Bancos'"
    [upIcone]="'account_balance'"
    [upCor]="'3F51B5'"
    [upDados]="bancos"
    [upColunas]="colunasListaDados"
    [upCarregando]="!!subscription"
    [upHabilitaEditarLinha]="true"
    [upLargura]="1"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    (ueBotaoExcluir)="onDelete($event)"
    (ueSalvarLinha)="onSalvarLinha($event)">
  </app-lista-dados>
</div>
